import { ActionReducer } from "@ngrx/store";
import {
  localStorageSync
} from "ngrx-store-localstorage";

import { User } from "../model/user/user.model";
import {
  copyObjectWithoutNullsOrGraphQLMetaKeys
} from "../util/object-utils";
import {
  TemporalContext
} from "./temporal.reducers";
import { UserContext } from "./user.reducers";

import { LS_PREFIX } from "../util/string-constants";

const config = {
  keys: [
    'reference',
    {
      user: {
        deserialize: (state: any) => {
          const ret = {
            ...state,
            profile: User.ToValidContextObject(state.profile),
            lastActiveTimestamp: new Date(state.lastActiveTimestamp)
          };
          return ret;
        },
        serialize: (state: UserContext) => {
          if (null == state) {
            return null;
          }
          const ret = {
            ...state
          };

          const profile = User.ToValidContextObject(state.profile);
          if (null == profile) {
            ret.profile = null;
          } else {
            ret.profile = {
              ...profile,
              Settings: profile.Settings ? profile.Settings.serialize() : {},
              Features: profile.Features ? profile.Features.serialize() : {},
              Preferences: profile.Preferences ? profile.Preferences.serialize() : {}
            };
          }

          return ret;
        }
      }
    },
    'ux',
    'demo',
    'dimension',
    {
      temporal: {
        filter: ['range', 'rangesByType', 'aggregation', 'L4L', "dateType", "dayType"],
        deserialize: (data: any) => {
          const ret = TemporalContext.ToValidContextObject(data);
          // console.log("Restored from LS:", ret);
          return ret;
        }
      }
    },
    {
      serialize: (toClean: object) => {
        console.log("Saving to LS:", toClean);
        return copyObjectWithoutNullsOrGraphQLMetaKeys(toClean)
      }
    }
  ],
  rehydrate: true,
  // If you ever need to see what is about to be persisted this is the easiest thing to uncomment.
  // It's called every time the state is about to be synced
  // and as long as it returns true you can do what you like in here.
  // syncCondition: (state: any) => {
  //   console.log("CALLED SYNC", JSON.parse(JSON.stringify(state)));
  //   return true;
  // },
  storageKeySerializer: (key: string) => LS_PREFIX + key
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync(config)(reducer);
}
